module.exports = __webpack_public_path__ + "static/img/technology-3.23153e9e.png";